<template>
  <transition :name="animationClass">
    <component
      :is="levelComponent"
      v-if="isVisible && levelComponent"
      v-bind="levelProps"
      class="level-page"
    />
  </transition>
</template>

<script>
import { categories } from "../utils/levelData.js";
import useEnterAnimation from "../composables/useEnterAnimation.js";

export default {
  name: "LevelPage",

  beforeRouteUpdate(to, from, next) {
    if (!this._isGoingToComplete(to)) {
      this.$store.dispatch("levelSessions/finalizeIfNeeded");
    }
    this.setLevelFromParams(to.params);
    next();
  },

  beforeRouteLeave(to, from, next) {
    if (!this._isGoingToComplete(to)) {
      this.$store.dispatch("levelSessions/finalizeIfNeeded");
    }
    next();
  },

  setup() {
    const { isVisible, animationClass } = useEnterAnimation(100, "fade-scale");
    return { isVisible, animationClass };
  },

  data() {
    return {
      levelComponent: null,
      levelProps: {},
      levelTitle: "",
      levelId: "",
    };
  },

  created() {
    this.setLevelFromParams(this.$route.params);
  },

  mounted() {
    window.addEventListener("beforeunload", this._handleBeforeUnload);
  },

  beforeUnmount() {
    this.$store.dispatch("levelSessions/finalizeIfNeeded");
    window.removeEventListener("beforeunload", this._handleBeforeUnload);
  },

  methods: {
    setLevelFromParams(params) {
      const categoryName = params.category;
      const levelIndex = parseInt(params.level, 10);

      const category = categories.find((c) => c.name === categoryName);
      if (!category) {
        this.$router.push("/");
        return;
      }

      const level = category.levels.find((l) => l.index === levelIndex);
      if (!level) {
        this.$router.push(`/${categoryName}`);
        return;
      }

      this.levelComponent = level.component;
      this.levelProps = level.props || {};

      const title =
        level.title ||
        level.name ||
        level.label ||
        `Level ${level.index} (${categoryName})`;

      this.levelTitle = title;
      this.levelId = `${categoryName}:${levelIndex}`;

      this.$store.dispatch("levelSessions/startSession", {
        levelId: this.levelId,
        title: this.levelTitle,
      });
    },

    _handleBeforeUnload() {
      this.$store.dispatch("levelSessions/finalizeIfNeeded");
    },

    _isGoingToComplete(to) {
      if (!to) return false;
      const byName = to.matched?.some((r) => r.name && /complete/i.test(String(r.name)));
      const byPath = to.matched?.some((r) => r.path && /(complete|congrats|success)/i.test(String(r.path)));
      return !!(byName || byPath);
    },
  },
};
</script>

<style scoped>
.level-page {
  margin-top: 20px;
}
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: opacity 2s ease, transform 2s ease;
}
.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.5);
}
.fade-scale-enter-to,
.fade-scale-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>